import { TRANSFORM_PRODUCT } from 'config';
import { removeBrandFromName } from '@/utils/General';

const getPrice = (price, currency = true) => {
  if (!price) return '';
  if (price.startsWith('$') && !currency) return price.substring(1);
  if (!price.startsWith('$') && currency) return `$${price}`;
  return price;
};

const transformProducts = (products) => {
  if (!products) return [];
  return products.map((product) => {
    const transformedProduct = {
      id: product.productId,
      orderNumber: product.orderNumber,
      itemReviewed: product.itemReviewed || false,
      beautyBoxProductFlag: product.beautyBoxProductFlag || false,
      marketPlaceOrder: false,
      lineNumber: product.lineNumber,
      imagery: {
        urlTemplate: product.urlTemplate,
        primaryImage: {
          filePath: product.primaryImageFilePath,
        },
      },
      identifier: {
        productUrl: product.productId ? `/shop/product/?ID=${product.productId}` : undefined,
      },
      detail: {
        name: removeBrandFromName(product.productBrand, product.productName) || TRANSFORM_PRODUCT.thereWasErrorText,
        brand: product.productBrand || (product.productName ? TRANSFORM_PRODUCT.productBrandText : TRANSFORM_PRODUCT.itemNameText),
        gmm: product.productGmm,
        colorAndSize: [product.upcSize, product.upcColor],
        quantity: product.quantity,
        upcNumber: product.upcNumber,
        orderToken: product.orderToken,
        shipmentToken: product.shipmentToken,
        productUrl: product?.productId ? `/shop/product/?ID=${product.productId}` : undefined,
      },
      price: [
        {
          values: [
            {
              value: getPrice(product.upcOrginalPrice, false),
              formattedValue: getPrice(product.upcOrginalPrice),
            },
          ],
        },
      ],
      traits: {
        colors: [product.upcColor],
        size: [product.upcSize],
      },
      pricing: {
        price: {
          tieredPrice: [
            {
              label: '[PRICE]',
              values: [
                {
                  type: 'regular',
                  value: getPrice(product.unitPrice, false),
                  formattedValue: getPrice(product.unitPrice),
                },
              ],
            },
          ],
        },
      },
    };

    const keys = [
      'mkpLineItemDetails',
      'mkpReturnReasons',
      'isLtlItem',
      'returnEligibleFlag',
      'lastActIndicator',
      'isReturnUnallowedFlag',
      'returnWindowDate',
      'returnPolicyDays',
      'inTransit',
      'shipmentStatusCode',
      'shipmentType',
      'isLoyaltyByPassApplied',
      'onlineOnlyReturn',
      'buyAgainFlag',
      'withProtectionPlan',
      'planDesc',
      'planProviderName',
      'protectionPlanPrice',
      'protectionPlanLabel',
      'protectionPlanStatus',
      'serviceLineId',
      'wnmPurchaseEligibility',
    ];

    keys.forEach((k) => {
      if (product[k]) {
        transformedProduct[k] = product[k];
      }
    });

    if (product.exchangeSubType) {
      transformedProduct.exchangeSubType = true;
    }
    if (product.mkpLineItemDetails?.sellerId) {
      transformedProduct.marketPlaceOrder = true;
    }
    transformedProduct.unitPriceWithoutCurrency = getPrice(product.unitPrice, false);

    return transformedProduct;
  });
};

const QUALITY_DEFAULT = '90,0';

const getProductThumbnailUrl = (url, path, width, quality = QUALITY_DEFAULT) => {
  if (!url || !path) return url + path;

  if (!url.toUpperCase().includes('[IMAGEFILEPATH]')) {
    return url + path;
  }

  return url
    .replace(/\[IMAGEFILEPATH]/gi, path)
    .replace(/\[WIDTH]/gi, String(width))
    .replace(/\[QUALITY]/gi, quality);
};

export { transformProducts, getPrice, getProductThumbnailUrl };
